import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './icomoon.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleAuthProvider } from './context/GoogleAuthContext';
import constants from 'utils/constants';
import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter>
      <GoogleOAuthProvider clientId={constants.GMAIL_CLIENT_ID}>
        <GoogleAuthProvider>
          <App />
        </GoogleAuthProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
);

serviceWorker.unregister();
